export default __webpack_public_path__ + "static/media/watch_light.ba63bbb7.png";